import RoleHome from '../RoleHome';

export default function ExecutivePage() {
  return (
    <RoleHome
      title="Executive"
      description="High‑level analytics and read access across key operational areas."
    />
  );
}
